module.exports = __webpack_public_path__ + "static/63import-71b6c24ca2e79d3f5d83aa560d82b444.png";